module.exports = __webpack_public_path__ + "img/b5.34efe6d8.png";